import React from 'react'
import InvoiceGenerator from '../components/InvoiceGenerator'
import FeatureGrid from '../components/FeatureGrid'
import TargetAudience from '../components/TargetAudience'
import {Zap, Clock, Shield} from 'lucide-react'

const HomePage = () => {
  return (
    <div className="w-full">
      {/* Hero Section with Generator */}
      <section className="bg-gradient-to-br from-[#0B5394] to-[#047857] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Create an Instant Invoice Now – No Sign-up Required
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 mb-6">
              The fastest way to send a professional PDF invoice or tax invoice to your clients.
            </p>
            
            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <div className="flex items-center gap-2">
                <Zap className="w-5 h-5 text-yellow-300" />
                <span>Quick invoice generator</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="w-5 h-5 text-yellow-300" />
                <span>Make an invoice right now</span>
              </div>
              <div className="flex items-center gap-2">
                <Shield className="w-5 h-5 text-yellow-300" />
                <span>Simple invoice software</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Invoice Generator Widget */}
      <section id="invoice-generator" className="bg-white py-12 -mt-8">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <InvoiceGenerator />
        </div>
      </section>

      {/* Feature Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900">
            Everything You Need for Professional Invoicing
          </h2>
          <FeatureGrid />
        </div>
      </section>

      {/* Target Audience */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-gray-900">
            Perfect for Every Professional
          </h2>
          <p className="text-center text-gray-600 mb-12 text-lg">
            Trusted by thousands of professionals who need to email invoice quickly
          </p>
          <TargetAudience />
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-[#047857] to-[#10B981] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Get Paid Faster?
          </h2>
          <p className="text-xl mb-8 text-green-100">
            Create your first professional invoice in under 60 seconds
          </p>
          <button
            onClick={() => {
              const generator = document.getElementById('invoice-generator')
              generator?.scrollIntoView({ behavior: 'smooth' })
            }}
            className="bg-white text-[#047857] px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors shadow-lg"
          >
            Start Creating Invoices Now
          </button>
        </div>
      </section>
    </div>
  )
}

export default HomePage
